<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

const props = defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

const tag = computed(() => `h${Math.min(Math.max(props.data.level ?? 1, 1), 3)}`)
const sizeClass = computed(() => ({
  1: 'text-3xl sm:text-5xl',
  2: 'text-2xl sm:text-3xl',
  3: 'text-xl sm:text-2xl'
}[Math.min(Math.max(props.data.level ?? 1, 1), 3)]))
</script>

<template>
  <component
    :is="tag"
    class="site-display tracking-tight"
    :class="sizeClass"
  >
    {{ data.text }}
  </component>
</template>
